import { httpservice, Message } from 'src/app/commons/commons.module';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatAccordion } from '@angular/material/expansion';
import { CommonModule } from '@angular/common';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../_dialog/dialog.component';
import { VodomjeriloSlika } from './vodomjeriloslika';
import { Base64Pipe } from "../../commons/ImagePipe";
import { PrikazSlikeComponent } from '../prikaz-slike/prikaz-slike.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';


@Component({
  selector: 'prijava-kvara',
  templateUrl: './prijava-kvara.component.html',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatProgressSpinnerModule,PrikazSlikeComponent, MatCardModule, MatIconModule, MatButtonModule, MatInputModule],
})
export class PrijavaKvaraComponent implements OnInit {
  getservice: httpservice;
  lista: VodomjeriloSlika[];
  page: number;
  noviZahtjev: boolean;
  ispravakZahtjeva: boolean;
  ispravakNovog: boolean;
  currentItem: any;
  changelog: any;
  ucitavam: boolean=false;
  constructor(dataservice: httpservice, private router: Router, public dialog: MatDialog) {
    this.getservice = dataservice;
    this.page = 1;
  }
  ngOnInit() {    
    this.UcitajOtvorene();    
  }

  

  UcitajOtvorene() {
    this.getservice.GetRequest<Message>("radninalozi/PrijaveKvarova").subscribe(result => {
      if (result.status === "success") {
        this.lista = result.data;
      }
    }, error => console.error('Get zahtjev', error));
  }




  UcitajSliku(data: VodomjeriloSlika) {
    if (data.image == "") {
      this.ucitavam = true;
      this.getservice.GetRequest<Message>("radninalozi/PrijaveKvarovaSlika?id=" + data.vodomjeriloSlikaId).subscribe(result => {
        if (result.status === "success") {
          data.image = result.data;
          this.ucitavam = false;
        }
      }, error => {
        console.error('Get zahtjev', error)
        this.ucitavam = false;
      });
    }
  }
}
